import { useState } from "react";

import { useLocale } from "../stores/locale";

export function useAlertMessage() {
  const { locale: t, get: getLocale } = useLocale((state) => state);
  const [isOpen, setIsOpen] = useState(false);
  const [header, setHeader] = useState("");
  const [message, setMessage] = useState("");

  return {
    isOpen,
    header,
    message,
    setIsOpen,
    open: ({
      code,
      message,
      info,
    }: {
      code: string;
      message?: string;
      info?: string;
    }) => {
      if (message && info) {
        setHeader(message);
        setMessage(info);
        return;
      }
      if (message) {
        setHeader(t.error.code.title);
        setMessage(message);
        return;
      }

      setHeader(t.error.code.title);
      setMessage(getLocale("error.code.message", { error: code }));
      return;
    },
  };
}
